import * as React from 'react';

import { PercentageIcon, MortgageFilledIcon, StarFilledIcon } from '@cian/ui-kit/prev/icons';
import { TCssColor } from '@cian/ui-kit/prev/tooltip';
import { Tooltip } from './Tooltip/Tooltip';
import { TColors } from '../../types/colors';
import { INewbuildingPromo } from '../../types/newbuilding';
import { Container } from '../Container';
import {
  trackJKListPromoIconClick,
  trackJKListPromoIconHover,
  PromotionsJKListType,
} from '../../actions/analytics/event';

import * as styles from './PromoBlock.css';

export interface IPromoBlockProps {
  promos: INewbuildingPromo[];
  url: string;
  dataMark?: string;
}

export interface IPromoBlockState {
  currentPopUpIdx: number;
}

export interface IPromoAsset {
  color: TColors;
  hex: TCssColor;
  icon: typeof PercentageIcon | typeof MortgageFilledIcon | typeof StarFilledIcon;
  size: string;
  style: {
    top: string;
    left: string;
  };
}

const getAsset = (type: string): IPromoAsset | null => {
  switch (type) {
    case 'discount':
      return {
        color: 'red_2',
        hex: 'E84260',
        icon: PercentageIcon,
        size: '14',
        style: {
          top: '4px',
          left: 'calc(50% - 7px)',
        },
      };
    case 'mortgage':
      return {
        color: 'orange',
        hex: 'FF9D00',
        icon: MortgageFilledIcon,
        size: '18',
        style: {
          top: '3px',
          left: 'calc(50% - 9px)',
        },
      };
    case 'bonus':
      return {
        color: 'green',
        hex: '2E9E00',
        icon: StarFilledIcon,
        size: '16',
        style: {
          top: '4px',
          left: 'calc(50% - 8px)',
        },
      };
    default:
      return null;
  }
};

export interface IPromoProps {
  newbuildingLabel: string;
  promoType: string;
  specProject: boolean;
  setPopUp(idx: number): void;
  popUpIdx: number;
  currentPopUpIdx: number;
  url: string;
}

export const Promo = (props: IPromoProps) => {
  const { newbuildingLabel, promoType, setPopUp, currentPopUpIdx, popUpIdx } = props;
  let { url = '' } = props;

  const asset = getAsset(promoType);

  if (!asset) {
    return null;
  }

  if (url) {
    url = `${url}#promoList`;
  }

  const Icon = asset.icon;
  const onMouseEnter = () => {
    trackJKListPromoIconHover(promoType as PromotionsJKListType);
    setPopUp(popUpIdx);
  };

  const onMouseLeave = () => {
    setPopUp(0);
  };

  const onPromoClick = () => {
    trackJKListPromoIconClick(promoType as PromotionsJKListType);
  };

  return (
    <Container
      margin={`0 0 0 ${popUpIdx === 0 ? '0' : '-4px'}`}
      className={styles['promo-wrapper']}
      data-promo-type={promoType}
    >
      <Tooltip
        custom={{
          isOpen: currentPopUpIdx === popUpIdx,
        }}
        master={
          <a
            href={url}
            title="Все акции"
            target="_blank"
            onClick={onPromoClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
          >
            <Container
              className={styles['promo']}
              width="26px"
              height="26px"
              borderRadius="round"
              backgroundColor={asset.color}
              display="flex"
              justifyContent="center"
              alignItems="center"
            >
              <div style={{ position: 'absolute', ...asset.style }}>
                <Icon
                  custom={{ size: asset.size }}
                  styles={{ color: 'FFFFFF' }}
                />
              </div>
            </Container>
          </a>
        }
      >
        <a
          href={url}
          target="_blank"
          className={styles['promo-tooltip']}
          onClick={onPromoClick}
          title="Все акции"
          style={{ backgroundColor: `#${asset.hex}` }}
        >
          {newbuildingLabel}
        </a>
      </Tooltip>
    </Container>
  );
};
